import { ComponentType, FC } from 'react';

import { BUSINESS_PLAN_TYPES, IBusinessToolType } from 'constants/businessPlan';
import { useBusinessToolStore } from 'store/useBusinessToolStore';
import { getBusinessPlanType } from 'store/useBusinessToolStore/selectors';

import { IBusinessToolNavigationProps } from './types';
import { ForBankNavigation } from '../components/Navigation/ForBankNavigation';
import { ForInvestorNavigation } from '../components/Navigation/ForInvestorsNavigation';
import { OnePageNavigation } from '../components/Navigation/OnePageNavigation';
import { OnePageShortNavigation } from '../components/Navigation/OnePageShortNavigation';
import { TNavigationRenderFn } from '../types';

const businessToolNavigation: Record<IBusinessToolType, ComponentType<{ render: TNavigationRenderFn }>> = {
  [BUSINESS_PLAN_TYPES.ONE_PAGE]: OnePageNavigation,
  [BUSINESS_PLAN_TYPES.FOR_BANK]: ForBankNavigation,
  [BUSINESS_PLAN_TYPES.ONE_PAGE_SHORT]: OnePageShortNavigation,
  [BUSINESS_PLAN_TYPES.FOR_INVESTORS]: ForInvestorNavigation,
};

export const BusinessToolNavigation: FC<IBusinessToolNavigationProps> = ({ children }) => {
  const businessPlanType = useBusinessToolStore(getBusinessPlanType);

  const BusinessToolNavigationComponent = businessToolNavigation[businessPlanType];

  return <BusinessToolNavigationComponent render={children} />;
};
